<h1>Review your new vehicle quote</h1>

@if (quotes) {
  <amfam-quote-cards [quote]="quotes"></amfam-quote-cards>
}

<div class="gray-outline-box">
  <div class="flex justify-space-between wrap">
    <amfam-wrap-article
      [headerContentRef]="vehicleAdded?.headerContentRef"
      [content]="vehicleAdded?.content"
      [contentIconPath]="vehicleAdded?.contentIconPath"
    >
    </amfam-wrap-article>
    <amfam-wrap-article
      [headerContentRef]="vehicleRemoved?.headerContentRef"
      [content]="vehicleRemoved?.content"
      [contentIconPath]="vehicleRemoved?.contentIconPath"
    >
    </amfam-wrap-article>
  </div>

  <amfam-wrap-article
    [headerContentRef]="vehiclesLeft?.headerContentRef"
    [content]="vehiclesLeft?.content"
  >
  </amfam-wrap-article>
</div>

<amfam-wrap-section
  [headerContentRef]="vehicleCoverages?.headerContentRef"
  [iconClass]="vehicleCoverages?.iconClass"
  [itemList]="vehicleCoverages?.items"
></amfam-wrap-section>

<amfam-wrap-section
  [headerContentRef]="policyCoverages?.headerContentRef"
  [iconClass]="policyCoverages?.iconClass"
  [itemList]="policyCoverages?.items"
></amfam-wrap-section>
<amfam-wrap-section
  [headerContentRef]="discounts?.headerContentRef"
  [iconClass]="discounts?.iconClass"
  [itemList]="discounts?.items"
></amfam-wrap-section>
<amfam-wrap-section
  [headerContentRef]="futurePayments?.headerContentRef"
  [iconClass]="futurePayments?.iconClass"
  [itemList]="futurePayments?.items"
></amfam-wrap-section>

<div class="font-size-0-75" dsContent [contentPath]="'policy.premiumBilling.disclaimer'"></div>
